import * as React from "react";

const SvgComponent = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" {...props}>
		<path
			d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z"
			fill="#2eb5c0"
		/>
		<path
			d="M11.314 8.033c.194-.016.361.031.469.209l.715 1.185.772 1.409c.067.126.16.24.238.361l.207.346c.137.26.131.521-.073.728l-.919.855-.777.705a.53.53 0 0 0-.114.676l.63 1.138c.829 1.383 1.889 2.559 3.228 3.465l1.595.98c.511.289.71.24 1.107-.202l1.092-1.239c.088-.099.194-.188.297-.273a.574.574 0 0 1 .677-.075c.067.033.139.062.198.105.637.456 1.349.777 2.021 1.164l1.066.642c.191.113.268.278.255.505-.036.638-.142 1.265-.513 1.804a2.47 2.47 0 0 1-.598.578c-.616.431-1.303.697-2.034.86-.665.149-1.327.095-1.964-.104-1.229-.379-2.441-.813-3.556-1.471a15.623 15.623 0 0 1-2.785-2.131c-1.079-1.027-2.043-2.147-2.821-3.422-.508-.828-.87-1.719-1.198-2.629-.199-.549-.395-1.092-.483-1.674a3.99 3.99 0 0 1 .18-1.915c.189-.563.426-1.102.784-1.584.281-.374.632-.648 1.086-.771L11.192 8a.142.142 0 0 0 .122.033z"
			fill="#fff"
		/>
	</svg>
);

export default SvgComponent;
